import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getUsedBy = (usedById: number | undefined): Promise<IGetUsedBy> => {
  return axiosDefaultApi.get(`api/UsedBy/GetUsedByViaID/${usedById}`);
};

type QueryFnType = typeof getUsedBy;

type UseGetUsedByOptions = {
  usedById: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetUsedBy = ({ usedById , config }: UseGetUsedByOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getUsedBy_${usedById}`],
    queryFn: () => getUsedBy(usedById),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της παράμετρου 'Χρήση από'`, 500);
      setIsNotificationVisible(true)
    }
  });
};